import { getCompanyChannels } from 'adminPanel/api/companies';
import { Channel } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useCompanyChannels = (companyId: number) => {
    const [channels, setChannels] = useState<Channel[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getCompanyChannels(companyId)
            .then(setChannels)
            .finally(() => {
                setIsLoading(false);
            });
    }, [companyId]);

    return { channels, isLoading };
};
